// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"e00d4c33","235":"e702f9e3","289":"3852ce38","330":"7afb1217","471":"0cfc4e8c","730":"5b6cb957"}[chunkId] + ".chunk.js";
};